module.exports = __webpack_public_path__ + "static/media/img1-en-mobile.9c2d650a.png";